var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('Banner',{attrs:{"info":_vm.bannerInfo}}),_c('Eq'),_c('Video',{attrs:{"ytId":"NH-vGVNPV1s"}}),_c('Ad'),_c('Certification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }